export enum DifferenceStatus {
  POSITIVE = 'POSITIVO',
  NEGATIVE = 'NEGATIVO'
}